import { render, staticRenderFns } from "./ShareholderEngagement.vue?vue&type=template&id=19b272c4&scoped=true&"
import script from "./ShareholderEngagement.vue?vue&type=script&lang=js&"
export * from "./ShareholderEngagement.vue?vue&type=script&lang=js&"
import style0 from "./ShareholderEngagement.vue?vue&type=style&index=0&id=19b272c4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b272c4",
  null
  
)

export default component.exports